export default {
  getEditableItem: ({ activeAccount }) => activeAccount,
};
